module.exports = __webpack_public_path__ + "static/media/121.0fba6112.jpg";